import { FeedOverrideSection } from '@zg-rentals/ts-rental-manager-api-client';

export const FEED_OVERRIDES_TAG = 'feed-overrides';

// How long the UI keeps showing the "syncing with the feed" state after a feed-override edit. This is a
// client-side only heads-up (the backend re-import lock is being removed); tune to roughly how long a
// re-import takes to settle.
export const REIMPORT_LOCK_TTL_MS = 2 * 60 * 1000;

// TODO RECE-2305: re-enable once Policies and terms overrides reach the public listing. Until then the section's
// switch is hidden (unless already on, so it can be turned off) and it reads as off everywhere else, so its fields
// stay read-only on feed listings.
export const DISABLED_FEED_OVERRIDE_SECTIONS: ReadonlySet<FeedOverrideSection> = new Set([
  FeedOverrideSection.POLICIES,
]);
